/**
 * Amounts.
 */

/**
 * External dependencies
 */
import { useState } from 'react';

/**
 * WordPress dependencies
 */
import {
	__,
	sprintf,
} from '@wordpress/i18n';

/**
 * Internal dependencies
 */
import Amount from './Amount';
import Button from '../../Button';
import NumberInput from '../../NumberInput/NumberInput';

function Amounts({
		amounts = [],
		setAmount = () => {},
		currentAmount,
		minimumAmount,
		customAmount,
		setCustomAmount,
		frequency,
		disabled,
		error,
}) {
	const [custom, setCustom] = useState(false);

	const handleCustomAmount = (e) => {
		const value = e.target.value;
		setCustomAmount(value);
		setAmount(value);
	}

	return (
		<div className="dpf_amounts">
			<div className="dpf_amounts__list">
				{ ! custom &&
					<>
						{amounts.map((amount) =>
							<>
								{amount > 1 &&
									<Amount
										key={amount}
										value={amount}
										setAmount={() => setAmount(amount)}
										selected={amount === currentAmount}
										disabled={disabled}
									/>
								}
							</>
						)}
					</>
				}
				{ custom &&
					<NumberInput
						name="custom_amount"
						placeholder={ 'single' === frequency ? __('Choose your own amount', 'dekode-profundo-forms') : sprintf(__('Enter an amount of your choice, minimum %d.', 'dekode-profundo-forms'), minimumAmount)}
						min={minimumAmount}
						max={5000}
						onChange={handleCustomAmount}
						value={customAmount}
						disabled={disabled}
					/>
				}
				<Button
					onClick={() => setCustom( prevCustom => ! prevCustom )}
					customClass="dpf_custom-toggle"
					selected={custom}
				>
					{__('Custom Amount', 'dekode-profundo-forms')}
				</Button>
			</div>
			{ error &&
				<div className="dpf_amounts__error">{error}</div>
			}
		</div>
	)
}

export default Amounts;
